import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	icon,
} from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link } from "react-router-dom";

import OrganizeHeaderOrganisations from "./ui-components/OrganizeHeaderOrganisations.js";
import DefaultHeader from "./ui-components/DefaultHeader.js";

const icons = {
	hierarchy: (
		<FontAwesomeIcon
			icon={icon({ name: "list-tree", family: "sharp", style: "regular" })}
			className=""
		/>
	),
	list: (
		<FontAwesomeIcon
			icon={icon({ name: "list", family: "sharp", style: "regular" })}
			className=""
		/>
	),
	mapping: (
		<FontAwesomeIcon
			icon={icon({
				name: "link-horizontal",
				family: "sharp",
				style: "regular",
			})}
			className=""
		/>
	),
	overview: (
		<FontAwesomeIcon
			icon={icon({
				name: "house",
				family: "sharp",
				style: "solid",
			})}
			className=""
		/>
	),
	components: (
		<FontAwesomeIcon
			icon={icon({
				name: "computer",
				family: "sharp",
				style: "solid",
			})}
			className=""
		/>
	),
	organizations: (
		<FontAwesomeIcon
			icon={icon({
				name: "sitemap",
				family: "sharp",
				style: "solid",
			})}
			className=""
		/>
	),
	products: (
		<FontAwesomeIcon
			icon={icon({
				name: "box-archive",
				family: "sharp",
				style: "solid",
			})}
			className=""
		/>
	),
};

const Tab = (props) => {
	return (
		<div className={`${props.active ? activeHeader : ""}`}>
			<Link
				to={props.url}
				className={`${
					props.active ? "text-text-2" : "text-text-3"
				} block py-2 b-2 pr-4 pl-3 cursor-pointer hover:text-text-2 lg:hover:bg-transparent lg:border-0 lg:p-0`}
			>
				{/* <span className="mr-2">{props.icon}</span> */}
				{props.title}
			</Link>
		</div>
	);
};

const activeHeader =
	"border-solid border-bottom border-text-2 border-b-2 h-8plus";

const ContentHeader = (props) => {
	let location = useLocation();

	const [, setCurrentModule] = useState("");

	React.useEffect(() => {
		setCurrentModule(location.pathname);
	}, [location]);


	function goBack() {
		window.history.back();
	}

	let header;

	if (location.pathname === "/organize-organisations") {
		header = (
			<OrganizeHeaderOrganisations
				addOrganisation={() => props.addOrganisation()}
				mergeOrganisation={() => props.mergeOrganisation()}
				removeOrganisation={() => props.removeOrganisation()}
				headerOptions={props.headerOptions}
			/>
		);
	} else if (
		location.pathname === "/organize-components" ||
		location.pathname === "/components-mapping"
	) {
		header = (
			<div className="text-left flex-1 pt-4">
				<ul className="text-left flex flex-col lg:flex-row lg:space-x-24 font-normal text-lg leading-4">
					<li className="border-primary">
						<Tab
							title="Hierarchy"
							icon={icons.hierarchy}
							active={location.pathname === "/organize-components"}
							url="/organize-components"
						/>
					</li>
					<li>
						<Tab
							title="Mapping"
							icon={icons.hierarchy}
							active={location.pathname === "/components-mapping"}
							url="/components-mapping"
						/>
					</li>
				</ul>
			</div>
		);
	} else if (location.pathname === "/overview") {
		header = (
			<div className="text-left flex-1 pt-4">
				<ul className="text-left flex flex-col lg:flex-row lg:space-x-24 font-normal text-lg">
					<li className="border-primary">
						<Tab
							title="Overview"
							icon={icons.overview}
							active={location.pathname === "/organize-components"}
							url="/organize-components"
						/>
					</li>
					<li>
						<Tab
							title="IT Components"
							icon={icons.components}
							active={location.pathname === "/components-mapping"}
							url="/components-mapping"
						/>
					</li>
					<li>
						<Tab
							title="Organizations"
							icon={icons.organizations}
							active={location.pathname === "/components-mapping"}
							url="/components-mapping"
						/>
					</li>
					<li>
						<Tab
							title="Products"
							icon={icons.products}
							active={location.pathname === "/components-mapping"}
							url="/components-mapping"
						/>
					</li>
				</ul>
			</div>
		);
	} else {
		header = <DefaultHeader />;
	}

	return (
		<div className="bg-card h-[139px] pt-8 pl-4 border-b border-card-bd">
			<div className="text-2xl text-text font-semibold mb-4 flex flex-row">
			<FontAwesomeIcon
				icon={icon({
					name: "angle-left",
					family: "sharp",
					style: "solid",
				})}
				className="mr-4 text-sm flex-none pt-4 cursor-pointer"
				onClick={goBack}
			/>
				<div className="flex-1">
					{props.title}
					{/* <div className="text-lg font-normal mt-2">
						{props.subTitle}
					</div> */}
				</div>
			</div>
			<div className="">{header}</div>
		</div>
	);
};

export default ContentHeader;
